<template>
  <div>
    <div v-if="tableLoader || vocProductListLoader">
      <Loader />
    </div>
    <div class="row datepickerwrap card">
      <div
        class="d-flex justify-content-between tw-items-center  gap-4"
      >
        <div class="d-flex gap-3 tw-items-center flex-wrap">
          <div class="mr-2">
            <div
              class="mb-1 ml-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Date"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              style="width: 150px"
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDateTableDateRange"
              :max-date="maxDateTableDateRange"
              :single-date-picker="true"
              :ranges="false"
            >
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 170px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div> 
            <multiselect
              @input="handleChangePlatform"
              v-model="selectedPiePlatform"
              class="text-capitalize"
              :options="platforms"
              track-by="platform_id"
              label="platform_name"
              :multiple="false"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
            >
              <template #option="{ option }">
                <div class="custom-option text-capitalize">
                  {{ option.platform_name?.replaceAll("_", " ") }}
                </div>
              </template>
              <template #singleLabel="{ option }">
                <div class="custom-option text-capitalize">
                  {{ option.platform_name?.replaceAll("_", " ") }}
                </div>
              </template>
            </multiselect>
          </div>
          <div class="customMultiselectCommon mr-2" style="width: 200px">
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <!-- <select v-model="selectedPieCategory" @change="getPiePinList('platformChange')"
            class="form-control text-capitalize">
            <option v-for="category of categoryPieList" :key="category" :value="category" class="text-capitalize">
              {{ category.replaceAll("_", " ") }}
            </option>
          </select> -->
            <multiselect
              v-model="selectedPieCategory"
              class="text-capitalize"
              :options="categoryPieList"
              :multiple="false"
              :searchable="false"
              placeholder="Select Category"
              track-by="key"
              label="value"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              @input="handleChangePieCategory"
            >
              <!-- <template #option="{ option }">
							<div class="custom-option text-capitalize">
								{{ option.replaceAll('_', ' ') }}
							</div>
						</template> -->
            </multiselect>
          </div>
          <div
            class="customMultiselect mr-2"
            style="min-width: 160px; max-width: 180px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Product"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedPieASIN"
              :options="pieASINList"
              class="text-capitalize"
              label="product_name"
              :multiple="false"
              :searchable="true"
              placeholder="Select Product"
              selectLabel=""
              deselectLabel="Remove"
              track-by="sku"
              name="sku"
              :close-on-select="true"
            >
            </multiselect>
          </div>
          <div
            class="custom_pincode_dropdown customMultiselect mr-3"
            style="max-width: 180px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Pincode"][selectedLanguage.key] }}
            </div>
            <treeselect
              v-model="lossSelectedPIN"
              :options="lossPINList"
              track-by="id"
              label="label"
              value-consists-of="LEAF_PRIORITY"
              :limit="1"
              :disable-branch-nodes="false"
              placeholder="Select PIN(s)"
              :multiple="true"
              :searchable="true"
              @select="handleSelectTablePinChange"
            >
              <span slot="noResult">{{
                translatedLang["No elements found"][selectedLanguage.key]
              }}</span>
            </treeselect>
          </div>
          <div class="customMultiselectCommon mr-2" style="max-width: 220px">
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBatch"
              class="text-capitalize"
              :options="lossBatchList"
              track-by="batch"
              label="displayname"
              :multiple="false"
              :searchable="false"
              placeholder="Select Batch"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
            >
              <template #option="{ option }">
                <!-- <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedBatch"
                /> -->
                <span class="option__title ml-3 text-capitalize">{{
                  option.displayname.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 180px; max-width: 180px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Seller"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedSeller"
              class="text-capitalize"
              :options="sellerList"
              track-by="key"
              label="value"
              :multiple="false"
              :searchable="false"
              placeholder="Select Seller"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
            >
              <template #option="{ option }">
                <!-- <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedBatch"
                /> -->
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.value.replaceAll("_", " ") }}
              </template>
            </multiselect>
          
          </div>
          <div class="tw-mt-5">
            <button class="btn primarycolor" @click="handleApplyFilter">
              Apply Filters
            </button>
          </div>
        </div>
        <b-button size="sm" @click="handleBack" class="navigationButton"
          >{{ translatedLang["Back"][selectedLanguage.key] }}
        </b-button>
      </div>
    </div>
    <div>
      <div
        class="mt-2 card mx-2"
      >
        <div class="borderBottom d-flex align-items-center">
          <h4 class="graphHeading mr-2" style="margin-bottom: 12px !important">
            {{ translatedLang["Buybox Monitor"][selectedLanguage.key] }}
          </h4>
          <!-- <div> -->
          <!-- <div style="font-size: 12px !important;" v-if="storeTableStatus"
					:class="[`mb-2 text-capitalize badge ${getClassStatusWise}`]">
					{{ storeTableStatus }}
				</div> -->
          <!-- </div> -->
        </div>
        <table
          id="buybox_table"
          v-if="tableData?.length && buyboxTableDataShow"
          style="width: 99.9%; margin-right: 1px"
        >
          <thead class="thead-normal">
            <tr>
              <th v-for="header of tableHeader" :key="header.key">
                {{ header.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row1, index) of tableData" :key="index">
              <td style="min-width: 300px">
                <div>{{ row1.asin }}</div>
                <a
                  :href="row1.product_link"
                  target="_blank"
                  class="productTableNameBuybox"
                >
                  <span
                    style="
                      font-weight: 400;
                      color: rgb(22, 116, 149);
                      font-family: 'Heebo';
                      cursor: pointer;
                      text-transform: capitalize;
                      padding: 0 10px;
                      display: inline-block;
                    "
                  >
                    {{ row1.product_name }}
                  </span>
                </a>
              </td>
              <td
                v-for="header of tableHeader.slice(1, tableHeader.length)"
                :class="computeClass(header.key)"
                :key="header.key"
              >
                <div
                  v-for="(row2, idx) of row1.asin_data"
                  class="inner-row d-flex"
                  :key="`${row1.asin}_${idx}`"
                  :class="
                    header.key === 'all_offers'
                      ? ''
                      : 'justify-content-center align-items-center'
                  "
                >
                  <div v-if="header.key === 'action'">
                    <div class="mb-1">
                      <b
                        >{{
                          translatedLang["Other sellers"][selectedLanguage.key]
                        }}:&nbsp;</b
                      >{{ row2.other_sellers }}
                    </div>
                    <div v-if="row2.other_sellers > 0">
                       <div
                        v-if="
                          othersLoader &&
                          row1.asin === selectedAsinforOtherSeller &&
                          row2.pincode === selectedPincodeforOtherSeller
                        "
                        class="d-flex justify-content-center"
                      >
                        <b-spinner
                          small
                          type="grow"
                          variant="primary"
                        ></b-spinner>
                      </div>
                      <a
                        :style="{
                          color: 'rgb(22, 116, 149)',
                          cursor: othersLoader ? 'not-allowed' : 'pointer',
                          pointerEvents: othersLoader ? 'none' : 'auto',
                        }"
                        v-else
                        @click="
                          showSellerModal(
                            row1.asin,
                            row2.pincode,
                            row1.product_name
                          )
                        "
                      >
                        <i
                          class="fa fa-external-link"
                          style="font-size: 14px"
                        ></i>
                      </a>
                     
                    </div>
                  </div>
                  <ul v-else-if="header.key === 'all_offers'">
                    <li
                      class="text-left"
                      v-for="(offer, index) of row2['all_offers']"
                      :key="`${offer}-${index}`"
                    >
                      {{ offer }}
                    </li>
                  </ul>
                  <div
                    v-else-if="header.key === 'seller_name'"
                    :class="[
                      row2[header.key] === 'Out of Stock' && 'text-danger',
                    ]"
                  >
                    {{ row2[header.key] }}
                  </div>
                  <div
                    v-else-if="header.key === 'eta'"
                    :class="[
                      row2[header.key] === 'Out of Stock' && 'text-danger',
                    ]"
                  >
                    {{ row2[header.key] }}
                  </div>
                  <div v-else>{{ row2[header.key] || "-" }}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-else-if="!buyboxTableDataShow"
          class="onLoadingData m-2"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="text-danger m-2 d-flex justify-content-center border border-danger rounded mt-1 p-2 noData"
        >
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
        </div>
      </div>
      <b-modal
        size="xl"
        v-model="isSellerModal"
        style="z-index: 3000 !important"
        class="customModal"
      >
        <template #modal-title>
          <div
            style="font-weight: 500; font-size: 16px; color: #00555a"
            class="mb-3"
          >
            {{ translatedLang["Other sellers"][selectedLanguage.key] }}
          </div>
          <div
            style="
              text-transform: capitalize;
              width: 100%;
              text-overflow: ellipsis;
            "
            :title="sellerModalTitle"
          >
            {{ sellerModalTitle }}
          </div>
        </template>
        <table id="seller_table" class="w-100">
          <thead class="thead-normal">
            <tr>
              <th v-for="header of otherSellersTableHeader" :key="header.key">
                {{ header.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) of otherSellersTableData" :key="index">
              <td v-for="col of otherSellersTableHeader" :key="col.key">
                <span
                  v-if="col.key === 'seller_status'"
                  :class="getSellerStatusClass(row[col.key].key)"
                >
                  {{ row[col.key].value }}
                </span>
                <span v-else-if="col.key === 'seller_name'">
                  {{ row[col.key].value }}
                </span>
                <span v-else>{{ row[col.key] }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="newSellerContainer">
          <div
            class="newSellerCard position-relative mt-3"
            v-for="seller in storeAllNewSellerList"
            :key="seller.id"
          >
            <div class="newSellerLabelImgContainer position-absolute">
              <img
                src="../../../public/Icons_SVG/newSellerBuybox.svg"
                class="w-100"
              />
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="">
                <h5 class="mb-3 cardHeadingNewSeller">
                  {{
                    translatedLang["New seller available"][
                      selectedLanguage.key
                    ]
                  }}.
                  <span> {{ seller.seller_name.value }}</span>
                </h5>
                <div class="newSellerCardTags d-flex align-items-center">
                  <span class="text-capitalize newSellerCategory mr-2">
                    {{ seller.category.value.replaceAll("_", " ") }}</span
                  >
                  <span class="newSellerPincode">{{ seller.pincode }}</span>
                </div>
              </div>
              <div class="sellerTypeContainer d-flex">
                <label
                  class="mr-3 mb-0"
                  :class="[
                    `${
                      seller.auth ? 'authorized-seller' : 'unauthorized-seller'
                    }`,
                  ]"
                  >{{
                    seller.auth
                      ? `${translatedLang["Authorized"][selectedLanguage.key]}`
                      : `${
                          translatedLang["Unauthorized"][selectedLanguage.key]
                        }`
                  }}</label
                >

                <b-form-checkbox
                  v-model="seller.auth"
                  name="check-button"
                  switch
                  @change="updateSellerAuthStatus(seller)"
                  :class="[
                    `${
                      seller.auth ? 'authorized-seller' : 'unauthorized-seller'
                    }`,
                  ]"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";

export default {
  name: "BuyboxMonitor Details",
  components: {
    Multiselect,
    Datepicker,
    Loader,
    Treeselect,
  },
  data() {
    return {
      dateRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      minDateTableDateRange: "",
      maxDateTableDateRange: new Date(),
      platforms: [],
      selectedPlatform: "",
      categoryTableList: "",
      selectedTableCategory: "",
      selectedASIN: [],
      ASINList: [],
      selectAllBooleanProductIdForTable: false,
      getKeyForBuyboxPincode: JSON.parse(localStorage.reviewUserData).data
        .pincode_avaliable,
      PINList: [],
      selectedPIN: [],
      buyboxTableDataShow: false,
      tableHeader: [],
      tableData: [],
      vocProductListLoader: false,
      selectedPieCategory: [],
      categoryPieList: [],
      pieASINList: [],
      allCategory: [],
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map["Buy_Box_Monitor"],
      selectedPieASIN: {},
      lossSelectedPIN: [],
      lossPINList: [],
      lossSelectedBatch: [],
      lossBatchList: [],
      selectedSeller: [],
      sellerList: [],
      tableLoader: false,
      othersLoader: false,
      selectedPincodeforOtherSeller:'',
      selectedAsinforOtherSeller: '',
      allPINList: [],
      client: JSON.parse(localStorage.reviewUserData).data.client,
      isSellerModal: false,
      loaderSellerUpdateNew: false,
      sellerModalTitle: "",
      otherSellersTableHeader: [],
      otherSellersTableData: [],
      storeAllNewSellerList: [],
      pincodeCheck: false,
      selectedPiePlatform: null,
    };
  },
  mounted() {
    if (JSON.parse(localStorage.reviewUserData).data.buybox_channels) {
      this.platforms = JSON.parse(
        localStorage.reviewUserData
      ).data.buybox_channels_new;
      this.selectedPlatform = this.platforms[0];
    }
    this.getLastUpdatedDates();
    // this.getCategoriesForBuybox();
   // this.getFiltersData();
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),

    handleApplyFilter(){
      // if ($.fn.DataTable.isDataTable("#buybox_table")) {
      //   $("#buybox_table").DataTable().clear().destroy();
      // }   
            this.getPieChartsData();
   
      // this.getBuyBoxTable();

    },

    updateSelectedLabels(option) {
      return option.value.replaceAll("_", " ");
    },
    handleBack() {
      window.location = "#/buy-box-monitor";
    },
    // handleDateRange() {
    //   this.getBuyBoxTable();
    // },
    checkedAllAndRemove() {
      let length = 0;
      this.ASINList.forEach((items) => {
        length += 1;
      });

      if (length === this.selectedASIN.length) {
        this.selectAllBooleanProductIdForTable = true;
      } else {
        this.selectAllBooleanProductIdForTable = false;
      }
    },
    handleChangePlatform() {
      this.selectedPieASIN = [];
      this.lossSelectedPIN = [];
      this.selectedSeller = [];
      if (this.selectedPiePlatform) {
        const selectedPlatformKey = this.selectedPiePlatform.platform_name;
        this.categoryPieList = this.allCategory[selectedPlatformKey] || [];
        this.selectedPieCategory = this.categoryPieList[0] || null;
        // this.lossPINList =
        //   this.allPINList[this.selectedPiePlatform.platform_name];
        this.getSellerData();
        this.changeFilterData();
        // this.getBuyBoxTable();
      }
    },
     handleSelectTablePinChange(newVal) {
     
      const selectedValue = [newVal]
      if(selectedValue.some((data)=>data.label==='All')){
        if(this.lossSelectedPIN.length>=1){
          // console.log("inside if")
          this.$nextTick(() => {
            this.lossSelectedPIN =['all'];
          });
        }
      }
      else if(selectedValue.some((data)=>data.label!=='All')){
        this.$nextTick(() => {
          this.lossSelectedPIN = this.lossSelectedPIN.filter((val) => val !=='all');
        });
      }
      // this.handleChangeCategory();
    },
    handleChangePieCategory() {
      this.selectedPieASIN = null;
      this.changeFilterData();
      // this.getSellerData();
    },
    handleChangeCategory() {
   
      this.getBuyBoxTable();
      this.getSellerData();
    },
    handleChangeSeller() {
      this.getBuyBoxTable();
    },

    getLastUpdatedDates() {
      this.loader0 = true;
      this.tableLoader = true
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http.get(url).then(
        (response) => {
          if (response.body.data.buybox_monitor) {
          this.dateRange.endDate = moment(
              response.body.data.buybox_monitor.end_date
            ).format("YYYY-MM-DD");
            this.dateRange.startDate = moment(
              response.body.data.buybox_monitor.end_date
            ).format("YYYY-MM-DD");
            // localStorage.buybox_monitor_last_update = JSON.stringify(
            //   response.body.data.buybox_monitor
            // );

            // this.dateRange =
            //   response.body.data.buybox_monitor[this.selectedPiePlatform.key];
            this.loader0 = false;
            this.tableLoader = false;
            this.getCategoriesForBuybox().then(()=>{
              this.getFiltersData(true);
            })
            // this.getBuyBoxLossTable();

            this.showNoDataImgForUser = false;
          } else {
            this.loader0 = false;
            this.loader1 = false;
            this.loader = false;
            this.tableLoader = false;
            this.showNoDataImgForUser = true;
          }
        },
        (err) => {
          this.loader0 = false;
          this.getBuyBoxTable();
        }
      );
    },
     getFiltersData() {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
       self.$http
        .post(url, payload)
        .then((response) => {
          // this.lossPINList =  response.data.data.pincode[this.selectedPiePlatform?.platform_name];
          // this.allPINList = response.data.data.pincode;
          this.getSellerData();
          this.lossBatchList = response.data.data.batch["buy box monitor"];
          this.lossSelectedBatch = this.lossBatchList[0];
          // this.setPlatformWiseDateTable(true);
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    getSellerData() {
      // if ($.fn.DataTable.isDataTable("#buybox_table")) {
      //   $("#buybox_table").DataTable().clear().destroy();
      // }
      const url = "/api/v2/seller/data";
      const payload = {
        channel: this.selectedPiePlatform.platform_name,
        category: this.selectedPieCategory.key,
        pincode: this.lossSelectedPIN,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.sellerList = res.data?.data;
          // this.selectedSeller = this.sellerList.length
            // ? this.sellerList[0]
          //   : [];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getPieChartsData() {
      //   this.loader1 = true;
      //   this.pieChartBuyBoxDataShow = false;
      //   this.processedPieChartData = {};

      const url = "/api/v2/indian_clients/buy_box/data/pie_charts";
      const payload = {
        // pincodes: this.selectedPiePIN,
        pincodes: this.lossSelectedPIN,
        // asin: this.selectedPieASIN,
        client: this.client,
        // category: "23611a6bc3ae429e8fe1436a37cd458a",
        category: this.selectedPieCategory?.key,
        timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPiePlatform.platform_name,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

      this.$http.post(url, payload).then(
        (response) => {
          // this.loader1 = false;
          // this.pieASINList = response.data.data.asin_list;
          // this.selectedPieASIN = response.data.data.selected_asin;
          this.getBuyBoxTable();
          this.loader1 = false;
        },
        (err) => {
          self.loader1 = false;
        }
      );
    },
    computeClass(key) {
      if (key === "all_offers") {
        return "expanded-col";
      } else if (key === "eta") {
        return "mid-col";
      } else return "inner-cols";
    },
    toggleSelectAll() {
      this.selectAllBooleanProductIdForTable =
        !this.selectAllBooleanProductIdForTable;
      this.selectedASIN = [];
      if (this.selectAllBooleanProductIdForTable) {
        this.ASINList.forEach((items) => {
          this.selectedASIN = [...this.selectedASIN, items];
        });
      } else {
        this.selectedASIN = [];
      }
    },
    changeBuyBoxTableFilter(state = "") {
      if ($.fn.DataTable.isDataTable("#buybox_table")) {
        $("#buybox_table").DataTable().clear().destroy();
      }
      this.loader = true;
      // this.setPlatformWiseDateTable(false);
      if (state === "categoryChange") {
        this.selectedASIN = [];
        this.selectAllBooleanProductIdForTable = false;
        this.ASINList = [];
        this.selectedPIN = [];
        // this.changeTableCategory()
        if (Object.keys(this.storeAllDataForTableStatus).length) {
          this.storeTableStatus =
            this.storeAllDataForTableStatus[this.selectedPlatform.key][
              this.selectedTableCategory.key
            ];
        } else {
          this.storeTableStatus = "";
        }
      }
      if (state === "platformChange") {
        this.selectedPIN = [];
        this.selectedASIN = [];
        this.selectAllBooleanProductIdForTable = false;
        this.changeTableCategory();
        if (Object.keys(this.storeAllDataForTableStatus).length) {
          this.storeTableStatus =
            this.storeAllDataForTableStatus[this.selectedPlatform.key][
              this.selectedTableCategory.key
            ];
        } else {
          this.storeTableStatus = "";
        }
      }
      const url = "/api/v2/indian_clients/buy_box/data/primary";
      const payload = {
        pincodes: this.selectedPIN?.length ? this.selectedPIN : [],
        asins: this.selectedASIN?.length ? this.selectedASIN : [],
        category: this.selectedTableCategory.key,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform.key,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        seller: this.selectedSeller.key,
        // pincode_analysis: this.pincodeCheck
        feature_id: this.featureId,
      };

      // if (this.selectedASIN.length) {
      // 	payload["asins"] = this.selectedASIN;
      // }

      // if (this.selectedPIN.length) {
      // 	payload["pincodes"] = this.selectedPIN;
      // }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.ASINList = res.body.data.asin_list;
          this.PINList = this.convertToTreeFormat(res.body.data.pincode_list);
          this.loader = false;
        })
        .catch((err) => {
          console.log(err);
          // this.$bvToast.toast(`Error: Check console for detailed info.`, {
          // 	title: "Weavr Sense",
          // 	variant: "danger",
          // 	toaster: "b-toaster-top-right",
          // 	autoHideDelay: 3000,
          // });
          this.loader = false;
        });
    },
    changePlatform() {
      this.categoryPieList = [];
      this.pieASINList = [];
      this.selectedPieASIN = {};
      this.piePINList = [];
      this.selectedPiePIN = [];
      this.allPiePin = false;

      if (
        JSON.parse(localStorage.buybox_category_List) &&
        this.selectedPiePlatform
      ) {
        this.categoryPieList = JSON.parse(localStorage.buybox_category_List)[
          this.selectedPiePlatform.platform_name
        ];
        this.selectedPieCategory = this.categoryPieList[0];
      }
      // this.setPlatformWiseDatePie(false);
      if (
        Object.keys(this.storeAllDataForStatus).length &&
        this.selectedPiePlatform.platform_name
      ) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[this.selectedPiePlatform.platform_name][
            this.selectedPieCategory.key
          ]
        );
        // console.log('store for plat')
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
        // console.log('not store for plat')
      }
      // this.getLastUpdatedDates();
    },
    async getCategoriesForBuybox() {
      let self = this;
      self.vocProductListLoader = true;
      // const url = "/api/v2/india_clients/product_set_list";
      const url = "/api/v2/india_clients/product_platform_details";
      let payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      await self.$http
        .post(url, payload)
        .then((response) => {
          this.platforms = response.data.data.platform;
          this.selectedPiePlatform = this.platforms?.length
            ? this.platforms[0]
            : [];
          this.categoryPieList =
            response.data.data.price[this.selectedPiePlatform?.platform_name];
          this.allCategory = response.data.data.price;
          this.selectedPieCategory = this.categoryPieList?.length
            ? this.categoryPieList[0]
            : [];
          this.getPieChartsData();
          // this.setPlatformWiseDatePie(true);
          // this.setPlatformWiseDateTable(true);
          // this.getAllStatusByApi('forBuyBoxTable');
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    changeFilterData(){
      const url = "/api/v2/indian_clients/buy_box/data/primary";
      const payload = {
        pincodes: this.lossSelectedPIN.length ? this.lossSelectedPIN : [],
        asins:
          this.selectedPieASIN && this.selectedPieASIN.sku
            ? [this.selectedPieASIN]
            : [],
        category: this.selectedPieCategory.key,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPiePlatform.platform_name,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        seller: this.selectedSeller?.key,
        batch: this.lossSelectedBatch?.batch,
        // pincode_analysis: this.pincodeCheck
        feature_id: this.featureId,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.pieASINList = res.data?.data?.asin_list;
          this.lossPINList = res.data?.data?.pincode_list;
          this.lossSelectedPIN= res.data?.data.selected_pincodes        
        })
        .catch((err) => {
          this.buyboxTableDataShow = false;
          console.log(err);
          // this.$bvToast.toast(`Error: Check console for detailed info.`, {
          // 	title: "Weavr Sense",
          // 	variant: "danger",
          // 	toaster: "b-toaster-top-right",
          // 	autoHideDelay: 3000,
          // });
          this.loader = false;
          this.tableLoader = false;
        });
    },
    getBuyBoxTable() {
      if ($.fn.DataTable.isDataTable("#buybox_table")) {
        $("#buybox_table").DataTable().clear().destroy();
      }
      this.loader = true;
      this.tableLoader = true;
      this.buyboxTableDataShow = false;
      this.tableHeader = [];
      this.tableData = [];
      // $("#buybox_table").DataTable().destroy();
      const url = "/api/v2/indian_clients/buy_box/data/primary";
      const payload = {
        pincodes: this.lossSelectedPIN.length ? this.lossSelectedPIN : [],
        asins:
          this.selectedPieASIN && this.selectedPieASIN.sku
            ? [this.selectedPieASIN]
            : [],
        category: this.selectedPieCategory.key,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPiePlatform.platform_name,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        seller: this.selectedSeller?.key,
        batch: this.lossSelectedBatch?.batch,
        // pincode_analysis: this.pincodeCheck
        feature_id: this.featureId,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.tableHeader = res.data?.data?.headers;
          this.tableData = res.data?.data?.data;
          this.pieASINList = res.data?.data?.asin_list;
          this.lossPINList = res.data?.data?.pincode_list;
          this.lossSelectedPIN= res.data?.data.selected_pincodes
          this.tableHeader.push({
            key: "action",
            label: "View Other Sellers",
          });
          this.$nextTick(() => {
            $("#buybox_table").DataTable({
              initComplete: function (settings, json) {
                $(".dataTables_scrollBody tfoot tr").css({
                  visibility: "collapse",
                });
                $(".dataTables_scrollBody thead tr").css({
                  visibility: "collapse",
                });
                $("#buybox_table").wrap(
                  "<div style='overflow:auto; width:100%;position:relative;'></div>"
                );
              },
              language: {
                search: "",
                paginate: {
                  first: "",
                  previous: "<",
                  next: ">",
                  last: "",
                },
                lengthMenu: "<h5>Show entries</h5> _MENU_",
                searchPlaceholder: "Search...",
              },
              // dom: '<"top">frt<"bottom"l>p<"clear">',
              pagingType: "full_numbers",
              searching: true,
              sorting: [[1, "asc"]],
              autoWidth: false,
            });

            let search = require("../../../public/Icons_SVG/Search.svg");
            $("#buybox_table_filter > label").append(
              `<div><img src='${search}' width='20'/></div>`
            );

            var btn = $(
              '<input type="button" class="btn downloadBtn" value="Download" id="downloadBtn"/>'
            );
            $("#buybox_table_filter > label").append(btn);

            $("#downloadBtn").click(() => {
              this.downloadStandardExel();
            });
          });

          this.loader = false;
          this.tableLoader = false;
          this.buyboxTableDataShow = true;
        })
        .catch((err) => {
          this.buyboxTableDataShow = false;
          console.log(err);
          // this.$bvToast.toast(`Error: Check console for detailed info.`, {
          // 	title: "Weavr Sense",
          // 	variant: "danger",
          // 	toaster: "b-toaster-top-right",
          // 	autoHideDelay: 3000,
          // });
          this.loader = false;
          this.tableLoader = false;
        });
    },
    downloadStandardExel() {
      let self = this;
      this.loader = true;
      let payload = {
        pincodes: this.lossSelectedPIN.length ? this.lossSelectedPIN : [],
        asins:
          this.selectedPieASIN && this.selectedPieASIN.sku
            ? [this.selectedPieASIN]
            : [],
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPiePlatform.platform_name,
        pincode_analysis: this.pincodeCheck,
        category: this.selectedPieCategory.key,
        feature_id: this.featureId,
      };
      // if (this.selectedASIN.length) {
      // 	payload["asins"] = this.selectedASIN;
      // }

      // if (this.selectedPIN.length) {
      // 	payload["pincodes"] = this.selectedPIN;
      // }

      const url = "/api/v2/indian_clients/buy_box/data/report";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
        }
      );
    },
    showSellerModal(asin, pincode, productName) {
      if (this.othersLoader) return;
      this.othersLoader = true;
      this.selectedPincodeforOtherSeller = pincode;
      this.selectedAsinforOtherSeller = asin;
      const url = "/api/v2/indian_clients/buy_box/data/other";
      const payload = {
        pincode: pincode,
        asin: asin,
        category: this.selectedTableCategory.key,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPiePlatform.platform_id,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

      // if (!this.pincodeCheck) {
      //     this.sellerModalTitle = `${asin}`
      // } else {

      if (this.getKeyForBuyboxPincode) {
        this.sellerModalTitle = `${productName} - ${pincode}`;
      } else {
        this.sellerModalTitle = `${productName}`;
      }

      // }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.otherSellersTableHeader = res.body.data.headers;
          this.otherSellersTableData = res.body.data.data;
          this.storeAllNewSellerList = res.body.data.new_seller_list.map(
            (items) => {
              return {
                ...items,
                auth: false,
              };
            }
          );
          this.isSellerModal = true;
          this.othersLoader = false;
          this.selectedPincodeforOtherSeller = "";
          this.selectedAsinforOtherSeller = "";
          this.$nextTick(() => {
            $("#seller_table").DataTable({
              language: {
                search: "",
                paginate: {
                  first: "",
                  previous: "<",
                  next: ">",
                  last: "",
                },
                lengthMenu: "<h5>Show entries</h5> _MENU_",
                searchPlaceholder: "Search...",
              },
              // dom: '<"top">frt<"bottom"l>p<"clear">',
              pagingType: "full_numbers",
              searching: true,
              sorting: false,
              autoWidth: false,
              info: false,
            });
            let search = require("../../../public/Icons_SVG/Search.svg");
            $("#seller_table" + "_filter > label").append(
              `<div><img src='${search}' width='20'/></div>`
            );
          });
          this.loader = false;
        })
        .catch((err) => {
          this.othersLoader = false;
          this.selectedPincodeforOtherSeller = "";
          this.selectedAsinforOtherSeller = "";
          console.log(err);
          // this.$bvToast.toast(`Error: Check console for detailed info.`, {
          // 	title: "Weavr Sense",
          // 	variant: "danger",
          // 	toaster: "b-toaster-top-right",
          // 	autoHideDelay: 3000,
          // });
          this.loader = false;
        });
    },
    getSellerStatusClass(newSellerStatus) {
      return {
        "authorized-seller": newSellerStatus.toLowerCase() === "authorized",
        "unauthorized-seller": newSellerStatus.toLowerCase() === "unauthorized",
        "text-primary fw-500": newSellerStatus.toLowerCase() === "new",
      };
    },
    updateSellerAuthStatus(seller) {
      this.$nextTick(() => {
        const { seller_name, item_id, auth, pin_id } = seller;
        let self = this;
        self.loaderSellerUpdateNew = true;
        let payload = {
          seller_name: seller_name.key,
          item_id: item_id,
        auth: auth ? "authorized" : "unauthorized",
        pin_id: pin_id,
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };

        self.$http
          .post("/api/v2/indian_clients/buy_box/sellerstatus", payload)
          .then((response) => {
            // self.getBuyBoxTable();
            self.loaderSellerUpdateNew = false;
          })
          .catch((err) => {
            console.log(err);
            self.loaderSellerUpdateNew = false;
          });
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#buybox_table .inner-row::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 5px;
  background: #ebedee;
}

#buybox_table .inner-row::-webkit-scrollbar {
  height: 10px;
  width: 5px;
}

#buybox_table .inner-row::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #b3b2b9;
}

#buybox_table .inner-row::-webkit-scrollbar-thumb:hover {
  background: #8b8d94;
  cursor: pointer;
}
.inner-row:not(:last-child) {
  border-bottom: 1px solid var(--base_color-20) !important;
}
.inner-row {
  height: 80px !important;
  overflow-y: auto;
}
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}
.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 5px 0px !important;
}
.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
</style>
<style>
.authorized-seller {
  color: #00555a;
}

.custom-switch.authorized-seller .custom-control-label::after {
  background-color: #00555a !important;
  cursor: pointer !important;
}

.custom-switch.authorized-seller .custom-control-label::before {
  border: none !important;
  background-color: #00555a2b !important;
  cursor: pointer !important;
}

.custom-switch.unauthorized-seller .custom-control-label::after {
  background-color: #8f1616 !important;
  cursor: pointer !important;
}

.custom-switch.unauthorized-seller .custom-control-label::before {
  border: none !important;
  cursor: pointer !important;
  background-color: #8f16162e;
}

.unauthorized-seller {
  color: #8f1616;
}

.newSellerContainer
  .custom-control-input:focus
  ~ .custom-control-label::before {
  box-shadow: none !important;
}

.custom-switch .custom-control-label::before,
.custom-switch .custom-control-label::after {
  transform: scale(1.3);
}

.containerOverflowClass {
  overflow-x: visible !important;
}

@media screen and (max-width: 767px) {
  #buybox_table_paginate {
    float: none;
    width: auto;
  }
}
</style>
<style>
#buybox_table .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#buybox_table_paginate {
  position: relative;
  top: 6px;
  z-index: 100;
  float: right;
  /* width: 50vw; */
}

#buybox_table_info {
  position: relative;
  top: 9px;
  /* left: 324px; */
  left: 0;
  z-index: 100;
  /* float: right; */
  float: none;
  /* width: 50vw; */
  width: auto;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#buybox_table_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#buybox_table_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#buybox_table_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#buybox_table_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#buybox_table_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#buybox_table_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#buybox_table {
  border-radius: 20px 20px 0 0;
}

#buybox_table .thead-normal,
#buybox_table .thead-normal tr:first-child,
#buybox_table .thead-normal > tr:first-child > th:first-child {
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#buybox_table .thead-normal > tr:first-child > th:last-child {
  border-radius: 0 21px 0 0;
}

#buybox_table .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 500 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: black !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#buybox_table .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 600 !important;
  text-align: center !important;
  padding: 5px 25px 5px 25px !important;
  color: #5e5e5e !important;
  background-color: rgba(39, 86, 89, 0.1) !important;
  font-family: "Poppins" !important;
}

#buybox_table th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#buybox_table tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#buybox_table tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#buybox_table tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
  color: #5e5e5e !important;
  font-weight: 400 !important;
}

#buybox_table tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#buybox_table .even td {
  background: #fff !important;
}

#buybox_table .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #buybox_table_wrapper .bottom {
  margin-bottom: -30px;
} */
#buybox_table_wrapper .row:last-child {
  margin-bottom: 15px;
}

#buybox_table_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#buybox_table .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
  /* display: none; */
}

#buybox_table .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
  /* content: "" !important; */
  /* display: none; */
}
#buybox_table .thead-normal > tr > th.sorting_asc:before,
#buybox_table .thead-normal > tr > th.sorting_desc:after {
  opacity: 0.5;
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#buybox_table_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#buybox_table_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
  border:1px solid #065559 !important;
}

#buybox_table_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#buybox_table_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#buybox_table_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#buybox_table_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#buybox_table_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#buybox_table_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#buybox_table_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#buybox_table_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%)
    hue-rotate(138deg) brightness(98%) contrast(95%);
}

/* Modal Table */

#seller_table .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#seller_table_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#seller_table_info {
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#seller_table_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#seller_table_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#seller_table_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#seller_table_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#seller_table_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#seller_table_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#seller_table {
  border-radius: 20px 20px 0 0;
}

#seller_table .thead-normal,
#seller_table .thead-normal tr:first-child,
#seller_table .thead-normal > tr:first-child > th:first-child {
  /* background-color: var(--background) !important; */
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#seller_table .thead-normal > tr:first-child > th:last-child {
  border-radius: 0 21px 0 0;
}

#seller_table .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#seller_table .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 600 !important;
  text-align: center !important;
  padding: 10px 25px 10px 25px !important;
  color: #5e5e5e !important;
  font-family: "Poppins";
}

#seller_table th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#seller_table tr > td {
  padding: 10px !important;
}

#seller_table tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#seller_table tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#seller_table tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 14px !important;
  font-family: "Heebo", sans-serif !important;
  font-weight: 400 !important;
  color: #5e5e5e !important;
}

#seller_table tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#seller_table .even td {
  background: #fff !important;
}

#seller_table .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #seller_table_wrapper .bottom {
  margin-bottom: -30px;
} */
#seller_table_wrapper .row:last-child {
  margin-bottom: 15px;
}

#seller_table_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#seller_table .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}

#seller_table .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#seller_table_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#seller_table_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#seller_table_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#seller_table_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#seller_table_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#seller_table_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#seller_table_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#seller_table_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#seller_table_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#seller_table_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%)
    hue-rotate(138deg) brightness(98%) contrast(95%);
}

#buybox_table_filter .downloadBtn {
  margin: 0px 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

.allSelect {
  cursor: pointer;
  color: var(--primary_brand);
}

.allSelect:hover {
  background-color: var(--base_color-20);
}

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777a !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

/* .modal-title {
	font-weight: 400 !important;
	font-family: "poppins" !important;
	border-bottom: 1px solid #D5D5D5 !important;
	padding-bottom: 15px;
	color: #5E5E5E !important;
	font-size: 16px;
}


.modal-header {
	background: #fff !important;
	color: var(--base_color) !important;
	border: none !important;
	border-radius: 10px !important;
	font-family: "poppins" !important;
	word-break: break-all;
}

.modal-header .close {
	color: black !important;
	text-shadow: none !important;
	position: absolute !important;
	top: -2px !important;
	right: -6px !important;
	font-size: 30px !important;
	background: var(--primary_brand-10) !important;
	opacity: inherit !important;
	padding: 5px 10px !important;
	border-radius: 25px !important;
} */

/* new seller popup card style */
.newSellerCard {
  border: 1px solid #ebebeb;
  border-radius: 5px;
  padding: 16px;
}

.cardHeadingNewSeller {
  font-size: 14px;
  font-weight: 400;
  font-family: "Poppins";
  color: #5e5e5e;
}

.cardHeadingNewSeller span {
  font-size: 14px;
  font-weight: 600;
  font-family: "Poppins";
  color: #5e5e5e;
}

.newSellerCategory {
  background: #eaeaea;
  padding: 4px 8px;
  border-radius: 5px;
  font-size: 14px;
  font-family: "Heebo";
  color: #444444;
}

.newSellerPincode {
  font-size: 14px;
  font-family: "Heebo";
  color: #065559;
  padding: 4px 0;
  font-weight: 400;
}

/* .newSellerLabelImgContainer {
	width: 35px;
	height: 35px;
	left: -10px;
	top: -18px;
} */

.newSellerLabelImgContainer {
  width: 35px;
  height: 35px;
  left: -13px;
  top: -15px;
}

.authorized-seller {
  color: #00555a;
}

.custom-switch.authorized-seller .custom-control-label::after {
  background-color: #00555a !important;
  cursor: pointer !important;
}

.custom-switch.authorized-seller .custom-control-label::before {
  border: none !important;
  background-color: #00555a2b !important;
  cursor: pointer !important;
}

.custom-switch.unauthorized-seller .custom-control-label::after {
  background-color: #8f1616 !important;
  cursor: pointer !important;
}

.custom-switch.unauthorized-seller .custom-control-label::before {
  border: none !important;
  cursor: pointer !important;
  background-color: #8f16162e;
}

.unauthorized-seller {
  color: #8f1616;
}

.newSellerContainer
  .custom-control-input:focus
  ~ .custom-control-label::before {
  box-shadow: none !important;
}

.custom-switch .custom-control-label::before,
.custom-switch .custom-control-label::after {
  transform: scale(1.3);
}

.containerOverflowClass {
  overflow-x: visible !important;
}


</style>
